/** **bold** 마크다운을 파싱하여 세그먼트 배열로 변환 */
export const parseBoldSegments = (text: string): { text: string; bold: boolean }[] => {
  const segments: { text: string; bold: boolean }[] = [];
  const re = /\*\*(.+?)\*\*/g;
  let lastEnd = 0;
  let m;

  while ((m = re.exec(text ?? "")) !== null) {
    if (m.index > lastEnd) {
      segments.push({ text: text!.slice(lastEnd, m.index), bold: false });
    }
    segments.push({ text: m[1], bold: true });
    lastEnd = m.index + m[0].length;
  }

  if (lastEnd < (text ?? "").length) {
    segments.push({ text: text!.slice(lastEnd), bold: false });
  }

  return segments.length ? segments : [{ text: text ?? "", bold: false }];
};